module.exports = __webpack_public_path__ + "img/9.f56c8bdf.jpg";